
import Button, { ButtonProps } from '@mui/material/Button'
import { useTheme } from '@mui/material/styles'

type Props = Omit<ButtonProps, 'variant' | 'disableFocusRipple' | 'disableElevation'>

export default function TextButton(props: Props) {
  const theme = useTheme()
  const size = props.size || 'medium'

  const fontSize = {
    small: theme.typography.body2.fontSize,
    medium: theme.typography.body1.fontSize,
    large: theme.typography.h6.fontSize,
  }[size]

  return <Button
    {...props}
    size={size}
    sx={{
      minWidth: 0,
      fontSize,
      '&:active': {
        backgroundColor: (theme) => theme.palette.background.default,
      },
      transition: 'background-color 0.2s ease-in-out',
      padding: theme.spacing(1, 2),
      ...props.sx,
    }}
    variant='text'
    disableElevation
    disableRipple
  />
}